"use client";

import { useEffect } from "react";

const clarityProjectId = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID;
const clarityDebug = process.env.NEXT_PUBLIC_CLARITY_DEBUG === "true";
const shouldLoad = process.env.NODE_ENV === "production";

export function ClarityDebug() {
  useEffect(() => {
    if (!shouldLoad || !clarityProjectId || !clarityDebug) {
      return;
    }

    const logActivity = (event: Event) => {
      const clarityFn = window.clarity;
      const queueSize =
        clarityFn && Array.isArray(clarityFn.q) ? clarityFn.q.length : 0;

      console.info("[Clarity] activity", {
        type: event.type,
        clarityReady: typeof clarityFn === "function",
        queueSize,
      });
    };

    const logStatus = (phase: "initial" | "delayed") => {
      const inlineScript = document.getElementById("clarity-inline");
      const externalScript = document.querySelector(
        `script[src*="clarity.ms/tag/${clarityProjectId}"]`,
      );

      console.info("[Clarity] debug enabled", {
        phase,
        projectId: clarityProjectId,
        inlineScript: Boolean(inlineScript),
        externalScript: Boolean(externalScript),
      });
    };

    window.addEventListener("pointerdown", logActivity, { passive: true });
    window.addEventListener("keydown", logActivity);
    logStatus("initial");
    const statusTimeout = window.setTimeout(() => {
      logStatus("delayed");
    }, 2000);

    return () => {
      window.removeEventListener("pointerdown", logActivity);
      window.removeEventListener("keydown", logActivity);
      window.clearTimeout(statusTimeout);
    };
  }, []);

  return null;
}
